import { fromJS } from 'immutable';

export const salesroutes = {
  salesroutes: [],
  products: fromJS([]),
  questionnaires: fromJS([]),
  relations: fromJS([]),
  list: fromJS([]),
  map: fromJS([]),
  blockQuestionnaire: fromJS({}),
  blockOffers: fromJS({}),
  blockQuotation: fromJS({}),
  blockSubscription: fromJS({}),
  blockDocuments: fromJS({}),
  current: null,
  loading: {
    isLoadingSalesRoutes: false,
    isLoadingSalesRoute: false,
    isCreatingSalesRoute: false,
    isDeletingSalesRoute: false,
    isUpdatingSalesRoute: false,
    isLoadingQuestionnaires: false,
    isLoadingRelations: false,
    isLoadingProductDescriptions: false,
    //
    isLoadingQuestionnaireBlock: false,
    isLoadingQuotationBlock: false,
    isLoadingOffersBlock: false,
    isLoadingSubscriptionBlock: false,
    isLoadingDocumentsBlock: false,
  },
  advancement: fromJS({
    status: undefined,
  }),
  strings: {
    title: 'SalesRoutes',
    subtitle: undefined,
    'title.salesroute.list': 'SalesRoute',
    'title.salesroutes.list': 'SalesRoutes',
    'salesroutes.controls.info.label': 'salesroute(s) found',
    'salesroutes.grid.cell.actions.btn.view.label': 'View',
    'salesroutes.grid.cell.actions.btn.edit.label': 'Edit',
    'salesroutes.grid.cell.actions.btn.cancel.label': 'Cancel',
    'salesroutes.grid.cell.actions.btn.modify.label': 'Modify',

    'salesroutes.grid.column.id.label': 'Id',
    'salesroutes.grid.column.salesrouteName.label': 'Subscriber',
    'salesroutes.grid.column.status.label': 'Status',
    'salesroutes.grid.column.salesrouteId.label': 'SalesRoute',
    'salesroutes.grid.column.createdOn.label': 'Creation Date',
    'salesroutes.grid.column.date.label': 'Effective Date',
    'salesroutes.grid.column.commercialProductName.label': 'Product',

    'salesroutes.grid.column.actions.label': 'Actions',

    'salesroutes.filter.label': 'Filtres',
  },
};
